// extracted by mini-css-extract-plugin
export default {"container":"style_container__Tfjrs","innerBox":"style_innerBox__yCHS+","link":"style_link__byuHP"};